module.exports = __webpack_public_path__ + "img/mesa_ls03i.ececd53e.png";